export default {
  title: 'Servers',

  titles: {
    one: 'Server',
    create: 'Create server',
    update: 'Update server',
    remove: 'Remove server'
  },

  labels: {
    title: 'Title',
    host: 'Host',
    port: 'Port',
    processor: 'Processor',
    search: 'Search'
  },

  contents: {
    confirm: {
      remove: 'Confirm remove server.'
    }
  },

  hints: {
    notFound: 'Servers not found.',
    host: 'Server address, e.g. example.com. Host and port pair must be unique',
    port: 'Port from 0 to 64000, e.g. 8080',
    other: 'Other'
  },

  tooltips: {
    favorites: 'Make the server a favorite',
    isActive: 'Server is active'
  },

  snackbars: {
    created: 'Server created',
    updated: 'Server updated',
    removed: 'Server removed'
  }
}
